<template>
  <v-snackbar v-model="show" top auto-height>
    <span :class="textColor">{{ text }}</span>
    <v-btn color="primary" flat icon @click="show = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    text: String,
    textColor: String
  },

  data () {
    return {
      show: false
    }
  },

  methods: {
    showSnackbar () {
      this.show = true
    }
  }
}
</script>
